import { onReady } from "#Utils/dom"

onReady(() => {
  const appSwitcherElement = document.getElementById("app-switcher")
  const appSwitcherToggle = document.getElementById("app-switcher-button")
  const profileDropdownElement = document.getElementById("profile-dropdown")
  const profileDropdownToggle = document.getElementById("profile-dropdown-toggle")
  const helpDropdownElement = document.getElementById("help-dropdown")
  const helpDropdownToggle = document.getElementById("help-dropdown-toggle")
  const app = document.querySelector(".l-app")

  const menus = [
    {
      element: appSwitcherElement,
      toggle: appSwitcherToggle,
      contentElement: appSwitcherElement?.querySelector(".l-inner"),
    },
    {
      element: profileDropdownElement,
      toggle: profileDropdownToggle,
      contentElement: profileDropdownElement?.querySelector(".l-inner"),
    },
    {
      element: helpDropdownElement,
      toggle: helpDropdownToggle,
      contentElement: helpDropdownElement?.querySelector(".l-inner"),
    },
  ].filter((menu) => menu.element && menu.toggle) // Only include menus where both element and toggle exist

  const isHidden = (element) => element?.classList.contains("hidden")

  const showElement = (element) => {
    if (!element) return
    element.classList.remove("hidden")
    hideOtherElements(element)
  }

  const hideElement = (element) => {
    if (!element) return
    element.classList.add("hidden")
  }

  const hideOtherElements = (element) => {
    menus.forEach((menu) => {
      if (menu.element != element) hideElement(menu.element)
    })
  }

  menus.forEach((menu) => {
    const { element, toggle } = menu

    if (toggle && element) {
      toggle.addEventListener("click", () => {
        isHidden(element) ? showElement(element) : hideElement(element)
      })
    }
  })

  // Handle clicks outside menus to close them
  if (app) {
    app.addEventListener("click", (event) => {
      // Check if the click was on a menu toggle, if so, don't close
      const isToggleClick = menus.some(
        (menu) =>
          menu.toggle && (menu.toggle === event.target || menu.toggle.contains(event.target)),
      )

      if (!isToggleClick) {
        menus.forEach((menu) => {
          if (menu.element && !isHidden(menu.element)) {
            hideElement(menu.element)
          }
        })
      }
    })
  }
})
